import { NormalizeApi } from "../normalizeApi";
const BASE_ENDPOINT = 'pay.rpc.payment-method';
export const PaymentApi = NormalizeApi({
  list: `${BASE_ENDPOINT}.list`,
  create: `${BASE_ENDPOINT}.save`,
  postSecure: `${BASE_ENDPOINT}.post-secure`,
  createWithRedirect: `${BASE_ENDPOINT}.add`,
  setMain: `${BASE_ENDPOINT}.set-main`,
  delete: `${BASE_ENDPOINT}.remove`
});